import React from "react";
import "../../styles/SalesFunnel.css";
import { Link } from "react-router-dom";
import UIservice from "../../Page-section/web-design-services/UIservice";
import Portfolio from "../../components/portfolio";

import Faq from "../../Page-section/web-design-services/Faq";
import {
  FaLightbulb,
  FaUsers,
  FaCode,
  FaCogs,
  FaAward,
  FaPaperPlane,
} from "react-icons/fa";

const UIprocess = () => {
  const points = [
    "Better search engine rankings",
    "Improved customer trust",
    "Higher conversion rates",
    "Faster website performance",
    "Stronger brand identity",
    "Better mobile user experience",
  ];
  const point = [
    "Strong online presence",
    "Better customer interaction",
    "Higher search engine rankings",
    "Improved mobile experience",
    "Increased conversions",
    "Enhanced brand credibility",
  ];

  const steps = [
    {
      id: 1,
      title: "Business Analysis",
      color: "green",

      icon: <FaLightbulb />,
      desc: "We begin by understanding your business goals, audience, and project requirements.",
    },
    {
      id: 2,
      title: "Research and Planning",
      color: "#0868a0",
      icon: <FaUsers />,
      desc: "Our team researches your industry and competitors to create an effective website strategy.",
    },
    {
      id: 3,
      title: "Design and Wireframing",
      color: "green",
      icon: <FaCode />,
      desc: "We create modern layouts and prototypes focused on usability and aesthetics.",
    },
    {
      id: 4,
      title: "Website Development",
      color: "#0868a0",
      icon: <FaCogs />,
      desc: "Our developers transform designs into fully functional and responsive websites.",
    },
    {
      id: 5,
      title: "Testing and Optimization",
      color: "green",
      icon: <FaAward />,
      desc: "Before launch, we test your website for: Responsiveness ,Performance ,Browser compatibility ,Security",
    },
    {
      id: 6,
      title: "Launch and Support",
      color: "#0868a0",
      icon: <FaPaperPlane />,
      desc: "Once approved, your website goes live with ongoing support and maintenance.",
    },
  ];
  return (
    <section className="sf-wrapper">
      <div className="sf-sidebar">
        <div className="sf-card">
          <h2>Our Services</h2>

          <ul className="sf-service-list">
            <li className="active">
              <Link to="/web-design-services">Web Design</Link>
            </li>
            <li>
              <Link to="/web-development-company-in-noida">
                Web Development
              </Link>
            </li>
            <li>
              <Link to="/social-media-marketing-services">
                Social Media Marketing
              </Link>
            </li>
            <li>
              <Link to="/seo-agency-noida">SEO Services</Link>
            </li>
            <li>
              <Link to="/content-marketing-services">Content Marketing</Link>
            </li>
            <li>
              <Link to="/ai-automation-services">AI Automation Services</Link>
            </li>

            <li>
              <Link to="/lead-generation-services">Lead Generation</Link>
            </li>
            <li>
              <Link to="/sales-funnel-optimization">
                Sales Funnel Optimization
              </Link>
            </li>
            <li>
              <Link to="/branding-agency-noida">Branding Services</Link>
            </li>
            <li>
              <Link to="/business-automation-services">
                Business Automation
              </Link>
            </li>
            <li>
              <Link to="/resources">Resources</Link>
            </li>
          </ul>
        </div>

        <div className="sf-card">
          <h2>Contact Info</h2>

          <div className="sf-contact">
            <p>Address :- Sector-62, Noida, India</p>
            <p>
              Phone :- <br />
              <a href="tel:+918368327503"> +91 8368327503</a> |{" "}
              <a href="tel:+919319563429"> +91 9319563429</a>
            </p>
            <p>
              Email :- <br />
              <a href="mailto:connect@empowerweb.in">connect@empowerweb.in</a>
            </p>
          </div>
        </div>
                <Portfolio />

      </div>
      <div className="sf-main-content">
        <section className="why-container">
          <div className="why-content">
            <h2>Why Businesses Need Professional Web Design Services</h2>

            <p>
              A website is regularly the primary interaction customers have
              together with your commercial enterprise. If your internet site
              looks old, hundreds slowly, or is tough to navigate, users can
              also go away at once. High-first-class web design services help
              groups create a wonderful first influence and improve client
              retention.
            </p>

            <ul>
              {points.map((item, index) => (
                <li key={index}>
                  <span className="check">✔</span> {item}
                </li>
              ))}
            </ul>

            <p>
              As a leading <b>web design company in india</b>, we help
              businesses create impactful digital experiences that guide
              long-term growth.
            </p>
          </div>
        </section>
        <section className="freight-container">
          <div className="freight-content">
            <h3>Modern Features We Include</h3>
            <p>
              Our modern websites include responsive layouts, fast loading
              speed, SEO optimization, secure architecture, mobile-friendly
              design, user-friendly navigation, social media integration, and
              conversion-focused features to improve user experience and
              business growth. Our websites are built with advanced features to
              improve performance and usability:
            </p>
            <div className="freight-boxes">
              <div className="box">
                <div>
                  <h4>Responsive layouts</h4>
                  <br />
                </div>
              </div>
              <div className="box">
                <div>
                  <h4>SEO optimization</h4>
                </div>
              </div>
              <div className="box">
                <div>
                  <h4>Secure architecture</h4>
                </div>
              </div>
            </div>
            <div className="freight-boxes">
              <div className="box">
                <div>
                  <h4>Fast loading speed</h4>
                  <br />
                </div>
              </div>
              <div className="box">
                <div>
                  <h4>Social media integration</h4>
                </div>
              </div>
              <div className="box">
                <div>
                  <h4>Social media integration</h4>
                </div>
              </div>
            </div>
          </div>
        </section>

        <UIservice />
        <section className="work-process-section">
          <h3 className="work-title">Our Web Design Process</h3>
          <p className="work-subtitle">
            Our web design process focuses on strategy, creative design,
            responsive development, testing, and launch to deliver fast,
            user-friendly, business-driven websites.
          </p>

          <div className="process-wrapper">
            {/* STEP LABELS */}
            <div className="process-line">
              {steps.map((step) => (
                <div
                  key={step.id}
                  className="process-step"
                  style={{ backgroundColor: step.color }}
                >
                  {step.title}
                </div>
              ))}
            </div>

            {/* STEP DETAILS */}
            <div className="process-grid">
              {steps.map((step) => (
                <div className="process-item" key={step.id}>
                  <div
                    className="process-iconv"
                    style={{ borderColor: step.color, color: step.color }}
                  >
                    {step.icon}
                  </div>
                  <h3 className="process-num" style={{ color: step.color }}>
                    {step.id.toString().padStart(2, "0")}
                  </h3>
                  <p className="process-text">{step.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="why-container">
          <div className="why-content">
            <h2>Benefits of Our Web Design Services</h2>
            <p>
              Choosing professional web design services offers multiple
              advantages:
            </p>
            <ul>
              {point.map((item, index) => (
                <li key={index}>
                  <span className="check">✔</span> {item}
                </li>
              ))}
            </ul>
          </div>
        </section>
        <section className="benefits-section">
          <div className="container">
            <div className="header">
              <div className="title-row">
                <h3>Why Choose Us?</h3>

                <p>
                  Choose us for creative web design, responsive development, SEO
                  optimization, fast performance, modern layouts, and
                  customer-focused digital solutions.
                </p>
              </div>
            </div>

            <div className="cards">
              <div className="card">
                <h3>Experienced Design Team</h3>
              </div>
              <div className="card">
                <h3>Customer-Centric Approach</h3>
              </div>
              <div className="card">
                <h3>SEO and Performance Focus</h3>
              </div>
              <div className="card">
                <h3>Mobile-First Design</h3>
              </div>
              <div className="card">
                <h3>Affordable and Scalable Solutions</h3>
              </div>
               <div className="card">
                <h3>End-to-End Support</h3>
              </div>
              
            </div>
          </div>
        </section>
        <Faq />
        <section className="operations-wrapper">
          <div className="operations-left">
            <h3>Get Started with Expert Web Design</h3>
          </div>
          <div className="operations-right">
            <p>
           Transform your online presence with expert web design services tailored to your business goals, delivering responsive, SEO-friendly, and conversion-focused websites.
            </p>
          </div>
        </section>
      </div>
    </section>
  );
};

export default UIprocess;
